import React from 'react';
import { connect } from 'react-redux';
import styles from './about.module.scss';
import { Helmet } from 'react-helmet';

const About = ({showHelmet = true, words}) => {
    const educationList = [words.educationText1, words.educationText2];
    const languages = [
        { label: words.armenian, value: words.native },
        { label: words.english, value: words.basic },
        { label: words.russian, value: words.native },
        { label: words.spanish, value: words.veryGood }
    ];

    return(
        <>
            {showHelmet && <Helmet>
                <meta 
                    name="keywords" 
                    content="programer, web, development"
                />
                <meta
                    name="description"
                    content="About Arman Gharibyan"
                />
                <title>{words.aboutMe}</title>
            </Helmet>}
            <section className={styles.container}>
                <div className={styles.header}>
                    <div className={styles.kicker}>{words.about}</div>
                    <h2 className={styles.title}>{words.aboutMe}</h2>
                </div>

                <div className={styles.grid}>
                    <article className={styles.leadCard}>
                        <p className={styles.text}>{words.aboutMeText}</p>
                    </article>

                    <div className={styles.sideColumn}>
                        <article className={styles.card}>
                            <div className={styles.cardTitle}>{words.education}</div>
                            <div className={styles.educationList}>
                                {educationList.map((item) => (
                                    <div key={item} className={styles.educationItem}>{item}</div>
                                ))}
                            </div>
                        </article>

                        <article className={styles.card}>
                            <div className={styles.cardTitle}>{words.languages}</div>
                            <div className={styles.languageList}>
                                {languages.map((item) => (
                                    <div key={item.label} className={styles.languageItem}>
                                        <span>{item.label}</span>
                                        <span className={styles.languageValue}>{item.value}</span>
                                    </div>
                                ))}
                            </div>
                        </article>
                    </div>
                </div>
            </section>
        </>
        
    )
}

const mapStateToProps = (state) => {
    return{
        words: state.main.words
    }
}

export default connect(mapStateToProps, {})(About)